import { getSiteOrigin } from './siteOrigin';

const BUSINESS_ID = '#moveandparcel-business';

export function buildOrganizationJsonLd() {
  const origin = getSiteOrigin();
  const base = `${origin}/`;

  const localBusiness = {
    '@type': 'LocalBusiness',
    '@id': `${base}${BUSINESS_ID}`,
    name: 'ProfiTrans-Mitter Kft. – Move and Parcel',
    url: base,
    telephone: '+36706050279',
    email: 'office@moveandparcel.eu',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Pécel',
      postalCode: '2119',
      streetAddress: 'Határ u. 3.',
      addressCountry: 'HU',
    },
    areaServed: ['Magyarország', 'Európa'],
    priceRange: '$$',
    description:
      'Nagyméretű csomagok, bútorok, raklapos áruk, kerékpárok és költöztetési küldemények szállítása.',
  };

  const services = [
    {
      '@type': 'Service',
      name: 'Csomag- és bútorszállítás',
      serviceType: 'Áruszállítás',
      provider: { '@id': `${base}${BUSINESS_ID}` },
      areaServed: ['HU', 'EU'],
      description: 'Nagyméretű és nehéz csomagok, bútorok házhozszállítása.',
    },
    {
      '@type': 'Service',
      name: 'IKEA és bútor házhozszállítás',
      serviceType: 'Bútorszállítás',
      provider: { '@id': `${base}${BUSINESS_ID}` },
      areaServed: ['HU', 'EU'],
    },
    {
      '@type': 'Service',
      name: 'Költöztetés és raklapos fuvar',
      serviceType: 'Költöztetés',
      provider: { '@id': `${base}${BUSINESS_ID}` },
      areaServed: ['HU', 'EU'],
    },
  ];

  return {
    '@context': 'https://schema.org',
    '@graph': [localBusiness, ...services],
  };
}
